import gql from 'graphql-tag'

export default gql`
  query users_hasOverdueInvoiceButton($id: ID!) {
    user(id: $id) {
      isFrozen
      hasOverdueInvoice
    }
  }
`
